var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 140,
    viewBox: "0 0 224 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.202 0.941406H106.31C100.759 0.941406 96.2627 5.43387 96.2627 10.9804V83.2028C96.2627 88.7494 100.759 93.2418 106.31 93.2418H187.523L208.17 114.056L207.282 93.2418H213.202C218.752 93.2418 223.249 88.7494 223.249 83.2028V10.9804C223.249 5.43387 218.752 0.941406 213.202 0.941406Z",
    stroke: "#FF85A4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2364 44.5273C31.3592 44.5273 0.657227 62.4554 0.657227 84.5663C0.657227 98.9305 13.6262 111.521 33.0923 118.59L30.5471 138.074L46.3293 122.305C53.4961 123.785 61.1988 124.597 69.2364 124.597C107.114 124.597 137.816 106.669 137.816 84.5663C137.816 62.4637 107.114 44.5357 69.2364 44.5357V44.5273Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 223.429,
    height: 138.706,
    fill: "white",
    transform: "translate(0.238281 0.523438)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.9a1bc38c6a829415b8ccc7dafa5a52a8.svg";
export { ForwardRef as ReactComponent };